import React from "react";
import Layout from "./Layout";
import { Button, Container, Typography } from "@mui/material";
import { useNavigate, useRouteError } from "react-router-dom";
import graphic from "../assets/empty.png";

const ErrorBoundary = () => {
  let error = useRouteError();
  const navigate = useNavigate();
  return (
    <Layout>
      <Container
        sx={{
          margin: "3rem auto",
          minHeight: "38vh",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img width={"10%"} src={graphic} alt="error image" />
        <Typography
          variant="body2"
          color={"error"}
          sx={{ margin: "1rem auto" }}
        >
          Oops!! It seems you have lost. Get back home and try again.
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          sx={{ margin: "1rem auto" }}
          onClick={() => navigate("/")}
        >
          Homepage
        </Button>
      </Container>
    </Layout>
  );
};

export default ErrorBoundary;
